export const SET_INITIAL_PACKAGE = 'SET_INITIAL_PACKAGE'

export const setInitialPackage = identifier => ({
  type: SET_INITIAL_PACKAGE,
  payload: identifier
})
